export const CLIENT_SHIFT_TYPES = {
  URGENT: "urgent",
  DAY: "day",
  NIGHT: "night",
  WEEKEND: "weekend",
  BANK_HOLIDAY: "bankHoliday",
};

export const CLIENT_SHIFT_TYPE_OPTIONS = [
  {
    value: CLIENT_SHIFT_TYPES.URGENT,
    label: "Urgent",
    description: "Hourly rate for urgent cover shifts.",
    upliftKey: "urgentUplift",
  },
  {
    value: CLIENT_SHIFT_TYPES.DAY,
    label: "Day (Weekday)",
    description: "Standard weekday daytime hourly rate.",
    upliftKey: null,
  },
  {
    value: CLIENT_SHIFT_TYPES.NIGHT,
    label: "Night",
    description: "Hourly rate for night shifts.",
    upliftKey: "nightUplift",
  },
  {
    value: CLIENT_SHIFT_TYPES.WEEKEND,
    label: "Weekend",
    description: "Hourly rate for Saturday and Sunday work.",
    upliftKey: "weekendUplift",
  },
  {
    value: CLIENT_SHIFT_TYPES.BANK_HOLIDAY,
    label: "Bank Holiday",
    description: "Hourly rate for bank holiday shifts.",
    upliftKey: "bankHolidayUplift",
  },
];

export const CLIENT_BOOKING_STATUS_COLOR = {
  processing: "primary",
  pending: "warning",
  approved: "success",
  rejected: "danger",
  cancelled: "secondary",
};
